import React from "react";

const ReportGodaPark = () => {
  return (
    <div style={{}}>
      <h2>
        Virtual Guide To Provide Immersive Experience Of Goda Park Using VR
      </h2>
      <p>
        Through the power of Virtual Reality (VR), we've created an immersive
        experience that allows you to explore Goda Park like never before. From
        lush greenery to tranquil ponds, every aspect of the park has been
        faithfully recreated in the digital realm.
      </p>
      <p>
        Our project has garnered significant recognition, winning{" "}
        <b>1st Prize in the DIPEX-2023 State Level Competition </b> and 2nd
        Prize in a college competition. Additionally, it has been covered by
        several local newspapers, highlighting its impact and innovation.
      </p>
      <p>
        We are grateful for the support of the{" "}
        <b> Nashik Municipal Smart City Development Corporation </b>, whose
        sponsorship made this project possible. Their investment in technology
        and tourism has allowed us to showcase the beauty of Goda Park to a
        wider audience.
      </p>
      <p>
        Through the Virtual Guide to Goda Park, users can embark on a virtual
        tour, learning about the park's history, biodiversity, and significance.
        Whether you're a nature enthusiast, a history buff, or simply curious
        about our hometown's attractions, this immersive experience offers
        something for everyone.
      </p>
      <p>
        So, put on your VR headset or fire up your AR app, and join us on a
        digital journey through Goda Park. Explore its wonders from the comfort
        of your own home and discover why it's such a beloved destination in
        Nashik.
      </p>

      <p>Headset Supported - HTC Vive, Meta Oculus</p>
      <p>Project was covered by many newpapers - </p>
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <img
          src="../godanews.jpeg"
          style={{ borderRadius: "7px", height: "350px", margin: "1rem" }}
          alt="Not Found"
        />
      </div>
    </div>
  );
};

export default ReportGodaPark;
